<br />
<mat-expansion-panel class="margen-expansion" expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Informe De Venta X Producto</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <app-filtro-agencia-usuario-distribuidora-fecha
    [infoFiltro]="infoFiltro"
    (propagar)="dataFiltro($event)"
  ></app-filtro-agencia-usuario-distribuidora-fecha>
</mat-expansion-panel>

<br />
<mat-expansion-panel class="margen-expansion" expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Resultados</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="row">
    <div class="col s12 m12 l12" style="text-align: center" [hidden]="!loading">
      <mat-spinner
        [diameter]="100"
        style="margin: 0 auto; top: 15px"
      ></mat-spinner>
    </div>
    <div class="col s12 m12 l12" [hidden]="loading">
      <table
        [hidden]="!haveData"
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        class="display"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>Id Producto</th>
            <th>Código Producto</th>
            <th>Descripción</th>
            <th>Cantidad Pedido</th>
            <th>Total Bruto</th>
            <th>Total Neto</th>
            <th>Kilos</th>
            <th>Arrobas</th>
            <th>Bultos</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dataVentaProducto">
            <td style="text-align: center">{{ item.idProducto }}</td>
            <td style="text-align: center">{{ item.idExProducto }}</td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.cantidad }}</td>
            <td>{{ item.totalBruto | currency: "$":"symbol":"1.0-0" }}</td>
            <td>{{ item.totalNeto | currency: "$":"symbol":"1.0-0" }}</td>
            <td>{{ item.kilos }}</td>
            <td>{{ item.arrobas }}</td>
            <td>{{ item.bultos }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</mat-expansion-panel>
